import './api/interceptors';

import { ExperimentProvider } from '@carvana/experiment';
import Cookie from '@carvana/stc-cookie';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { useEffect, Suspense } from 'react';
import { withLDProvider } from 'launchdarkly-react-client-sdk';
import { datadogRum } from '@datadog/browser-rum';
import Loading from '../app/loading';
import { initializeWebVitals } from './analytics/eventableWebVitals';
import mfeConfig from './mfeConfig';
import ExperimentLoader from './components/ExperimentLoader';
import { ExperimentQueryParamsHandler } from './components/ExperimentQueryParamsHandler';
import queryClient from './shared/queryClient';
import LandingPage from 'components/LandingPage';

const ldKey = process.env.CARVANA_APP_LAUNCH_DARKLY_SDK_KEY;

const LDProvider = withLDProvider({
  clientSideID: ldKey || 'unknown',
  context: {
    kind: 'user',
    key: 'stc-home',
    bcid: Cookie.getBcId() || 'unknown'
  },
  options: {
    inspectors: [
      {
        name: 'dd-inspector',
        type: 'flag-used',
        method: (key, detail) => {
          datadogRum.addFeatureFlagEvaluation(key, detail.value);
        }
      }
    ]
  }
});

const App = () => {
  useEffect(() => {
    mfeConfig();
    const browserCookie = Cookie.getBcId();
    const dev = process.env.NODE_ENV === 'development';
    if (dev && !browserCookie) {
      Cookie.setCookie('BrowserCookieId', '123456789', 30);
    }
  }, []);

  useEffect(() => {
    initializeWebVitals();
  }, []);

  return (
    <ExperimentProvider>
      <QueryClientProvider client={queryClient}>
        <Suspense fallback={<Loading />}>
          <ExperimentQueryParamsHandler />
          <ExperimentLoader>
            <LandingPage />
          </ExperimentLoader>
        </Suspense>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </ExperimentProvider>
  );
};

const LdApp = LDProvider(App);

export default LdApp;
